// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/send.js';

import { paths } from '../generated/send';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('send', Original, paths);
